<!-- 礼包领取 -->
<template>
  <div :class="$style.welfare">
    <div
      v-if="welfareConfig.gift_open_time && serverTime"
      ref="welfareContent"
      :class="$style['welfare-content']"
    >
      <img :src="giftImg" style="width: 4.96rem; height: 2.19rem;" />
      <template v-if="!isGiftOpen">
        <div :class="$style['gift-tip']">
          {{ welfareConfig.gift_tip }}
        </div>
        <btn-download :class="$style['btn-download']" />
      </template>
      <div v-else>
        <button
          :class="$style['btn-reserve']"
          :disabled="isGiftClaimed"
          @click="handleReservation"
        />
      </div>
    </div>
    <popup-frame ref="result">
      <div :class="$style['welfare-result']" />
    </popup-frame>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { PopupFrame, BtnDownload } from "@/components/widgets";
import { collectAward } from "@/api";

export default {
  name: "TheWelfare",
  components: {
    PopupFrame,
    BtnDownload
  },
  props: {
    welfareConfig: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters([
      "user",
      "serverTime",
      "giftId",
      "lotteryGiftId",
      "isGiftClaimed"
    ]),
    /** 礼包图片 */
    giftImg() {
      return (
        this.welfareConfig.gift_image ||
        "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
      );
    },
    /** 礼包是否已开放 */
    isGiftOpen() {
      if (!this.welfareConfig.gift_open_time || !this.serverTime) return false;
      const openTimestamp =
        new Date(
          this.welfareConfig.gift_open_time.replace(/-/g, "/")
        ).getTime() / 1000;
      return openTimestamp < this.serverTime;
    }
  },
  methods: {
    ...mapActions(["setOwnedGifts", "setLotteryCount"]),
    handleReservation() {
      if (this.user && Object.keys(this.user).length > 0) {
        this.reserveGift();
      } else {
        this.$emit("login", 2);
      }
    },
    async reserveGift() {
      if (!this.giftId) {
        this.$toast("后台未配置礼包ID");
        return;
      }
      // 领取基础礼包
      const { code } = await collectAward(this.giftId);
      if (code === 0) {
        // 领取抽奖次数礼包
        const lotteryRes = await collectAward(this.lotteryGiftId);
        if (lotteryRes.code === 0) {
          this.setOwnedGifts(this.lotteryGiftId);
          // 更新抽奖次数
          this.setLotteryCount(
            lotteryRes.data &&
              lotteryRes.data.extra &&
              lotteryRes.data.extra.residue
          );
        }
        this.$refs.result.show();
        // 将基础礼包添加到已获得礼包列表中的行为后置，是为了避免领取按钮状态过快更新
        this.setOwnedGifts(this.giftId);
      }
    }
  }
};
</script>

<style lang="less" module>
.welfare {
  .background-fill("./images/welfare-bg.jpg");

  height: 21.2rem;
  padding-top: 14rem;

  &-content {
    .size(10.79rem, 6.99rem);
    .background-fill("./images/welfare-content.png");

    padding-top: 2.89rem;
    text-align: center;
  }

  &-result {
    .size(100%);
    .background-fill("./images/welfare-result.png", 6.41rem 1.31rem, center);
  }
}

.gift-tip {
  margin-top: 0.04rem;
  margin-bottom: -0.15rem;
  font-size: 0.32rem;
  color: #e04512;
}

.btn-reserve {
  .size(5.03rem, 1.67rem);
  .background-fill("./images/btn_receive.png");

  display: inline-block;

  &:disabled {
    .size(4.7rem, 1.24rem);
    .background-fill("./images/btn_receive_disabled.png");

    margin-top: 0.23rem;
  }
}

.btn-download {
  .size(5.03rem, 1.67rem);
  .background-fill("./images/btn_download.png");

  display: inline-block;
}
</style>
